// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../../shared/services/build-number';
import pipCompletionStatuses from '../../../shared/utils/pip-completion-statuses';

const expiryStatuses = {
    EXPIRED: {
        displayedClassName: 'dot-icon-red',
        labelKey: 'EXPIRED'
    },
    OK: {
        displayedClassName: '',
        labelKey: 'DAYS_LEFT_WITH_COUNT'
    },
    TERMINATED: {
        displayedClassName: 'dot-icon-red',
        labelKey: 'TERMINATED'
    },
    WARNING: {
        displayedClassName: 'dot-icon-yellow',
        labelKey: 'DAYS_LEFT_WITH_COUNT'
    }
};

const getActiveStatus = days => {

    if (days < 0) {

        return 'TERMINATED';

    } else if (!days) {

        return 'EXPIRED';

    } else if (days > 0 && days < 90) {

        return 'WARNING';

    }

    return 'OK';

};

const getPipExpiryStatus = days => {

    const activeStatus = getActiveStatus(days);

    return expiryStatuses[activeStatus];

};

const PipDaysToExpiryWidget = props => {

    const pipExpiryStatus = getPipExpiryStatus(props.daysLeft);

    return (
        <div>
            {pipCompletionStatuses.includes(props.pipCompletionStatus) &&
                <div className='pip-days-to-expiry-widget'>
                    {props.metric === 'Y' && <span className={pipExpiryStatus.displayedClassName}/>}
                    {!props.showIndicatorOnly &&
                        <FormattedMessage
                            id={pipExpiryStatus.labelKey}
                            values={{
                                days: props.daysLeft,
                                daysToDisplay: buildNumber(props.daysLeft)
                            }}
                        />
                    }
                </div>
            }
        </div>
    );

};

PipDaysToExpiryWidget.displayName = 'PipDaysToExpiryWidget';
PipDaysToExpiryWidget.propTypes = {
    daysLeft: PropTypes.number.isRequired,
    metric: PropTypes.string.isRequired,
    pipCompletionStatus: PropTypes.string.isRequired,
    showIndicatorOnly: PropTypes.bool.isRequired
};

export default PipDaysToExpiryWidget;



// WEBPACK FOOTER //
// ./src/pip/shared/components/pip-days-to-expiry-widget.js